<template>
  <v-stepper
    v-if="current && current.validations"
    class="justify-center text-center"
    v-model="step"
  >
    <v-stepper-header elevation="0" class="justify-center my-10">
      <v-stepper-step
        v-for="(validation, index) in current.validations"
        :key="validation._id"
        :step="index + 1"
        :complete="validation.status === 'complete'"
        color="success"
        :rules="validation.status === 'rejected' ? [() => false] : []"
        >{{ labels[validation.type]
        }}<small v-if="validation.user"
          >{{ validation.user.name
          }}{{validation.reason ? `: ${validation.reason}` : ''}}</small
        ></v-stepper-step
      >
    </v-stepper-header>
    <v-btn
      text
      class="mb-10"
      outlined
      @click="openDialog('validation')"
      v-if="current.status === 'draft'"
      >Soumettre pour validation</v-btn
    >
    <v-btn
      text
      outlined
      class="mb-10 mx-5"
      v-if="
        $route.name === 'Validation Details' &&
        current.status !== 'accepted' &&
        current.status !== 'rejected' &&
        current.validations.find((v) => v.type === current.status).status ===
          'pending'
      "
      @click="openDialog('accept')"
      >Valider</v-btn
    >
    <v-btn
      text
      outlined
      class="mb-10 mx-5"
      v-if="
        $route.name === 'Validation Details' &&
        current.status !== 'accepted' &&
        current.status !== 'rejected' &&
        current.validations.find((v) => v.type === current.status).status ===
          'pending'
      "
      @click="openDialog('reject')"
      >Refuser</v-btn
    >
  </v-stepper>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({ step: 0 }),
  methods: { ...mapActions("dialog", ["openDialog"]) },
  computed: {
    ...mapState({
      current: (state) => state.orders.current,
      labels: (state) => state.orders.labels,
    }),
  },
};
</script>

<style>
.v-stepper,
.v-stepper__header {
  box-shadow: none !important;
}
</style>
